import styled, { css, keyframes } from 'styled-components';

import { media } from '@common/theme/media';

const slideIn = keyframes`
  0% {
    transform: translate3d(0, -200%, 0) scale(0.6);
    opacity: 0.5;
  }
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  0% {
    transform: translate3d(0, 0, -1px) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -150%, -1px) scale(0.6);
    opacity: 0;
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

type SlideProps = { $isVisible: boolean; $isMeasured: boolean };

const slidePanel = css<SlideProps>`
  display: flex;
  max-width: 100%;
  will-change: transform;
  opacity: ${({ $isMeasured }) => ($isMeasured ? 1 : 0)};

  ${({ $isMeasured, $isVisible }) =>
    $isMeasured &&
    css`
      animation: ${$isVisible ? slideIn : slideOut} ${$isVisible ? '350ms' : '400ms'}
        ${$isVisible ? 'cubic-bezier(0.21, 1.02, 0.73, 1)' : 'cubic-bezier(0.06, 0.71, 0.55, 1)'}
        forwards;

      @media (prefers-reduced-motion: reduce) {
        animation: ${$isVisible ? fadeIn : fadeOut} 200ms linear forwards;
      }
    `}
`;

export const ToastSlide = styled.div<SlideProps>`
  ${slidePanel}
`;

export const ToastDetail = styled.span`
  display: block;
  margin-top: 4px;
`;

export const DialogSlide = styled.div<SlideProps>`
  ${slidePanel}
  padding: 12px 8px 0;

  > * {
    width: 350px;
    max-width: 100%;
    min-width: 0;
  }

  ${media.desktop`
    > * {
      width: 397px;
    }
  `}
`;
